<div class="animated container-fluid container-filter">
    <form class="needs-validation" [formGroup]="form" novalidate>

        <h4>Envío de la Solicitud de Campaña</h4>
        <h5 *ngIf="solicitudCam?.Codigo" style="display:inline;">Código de Solicitud: {{ solicitudCam?.Codigo }}</h5>
        <h5 style="display:inline" [ngClass]="{ 'ms-1': solicitudCam?.Codigo }">
            <span *ngIf="!solicitudCam?.Codigo">Estado de la solicitud: </span>
            <span>
                <img *ngIf="form.value.IdEstadoSolicitudCam" class="estado-icono-big" container="body" src="{{ form.value.IdEstadoSolicitudCam | IconoEstadoSolicitudCam }}" ngbTooltip="{{ solicitudCam?.EstadoSolicitudCam }}" />
                <img *ngIf="!form.value.IdEstadoSolicitudCam" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudCam }}" ngbTooltip="{{ 'Nueva' }}" />
            </span>
        </h5>
        <ng-container *ngIf="solicitudCam?.FechaSolicitud">
            <h5>Fecha de envío: {{ solicitudCam?.FechaSolicitud | date:'dd/MM/yyyy HH:mm' }}</h5>
            <div class="mt-1" style="display: flex">
                <span *ngIf="visibilityCheckEnvioValue !== null">
                    <img class="check-envio" src="{{ visibilityCheckEnvioValue | IconoCheckEnvio }}" />
                </span>
                <div class="nota-info col-12" [ngClass]="{ 'ms-1': visibilityCheckEnvioValue !== null, 'warning': visibilityCheckEnvioValue === false }">
                    <label class="col-form-label" for="">{{ mensajeEmision }}</label>
                </div>
            </div>        
        </ng-container>

        <div class="pt-2 row">
            <div class="col-md-12">
                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-file-text-o"></i> Datos Solicitud de Campaña
                            <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body-detalle">
                        <div class="collapse group-filtros" id="collapseCabecera" [ngbCollapse]="isCollapsedCabecera">

                            <div class="row">

                                <div class="form-group col-md-3 col-sm-6">
                                    <label class="col-form-label" for="Campania">Campaña</label>
                                    <input formControlName="Campania" name="Campania" class="form-control" id="Campania" type="text" value="">
                                </div>

                                <div class="form-group col-md-3 col-sm-6">
                                    <label class="col-form-label" for="Periodo">Periodo</label> <label class="small">(de la "Campaña")</label>
                                    <input formControlName="Periodo" name="Periodo" class="form-control" id="Periodo" type="text" value="">                                         
                                </div>

                                <div class="form-group col-md-3 col-sm-6">
                                    <label class="col-form-label" for="DescripcionComunidad">Comunidad Autónoma</label> <label class="small">(del "Periodo")</label>
                                    <input formControlName="DescripcionComunidad" name="DescripcionComunidad" class="form-control" id="DescripcionComunidad" type="text" value="">
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="EntidadAuditora">Entidad Auditora</label> <label class="small">(de la "Comunidad")</label>
                                    <input formControlName="EntidadAuditora" name="EntidadAuditora" class="form-control" id="EntidadAuditora" type="text" value="">
                                </div>

                            </div>
                            <div class="row">

                                <div class="form-group col-md-3 col-sm-6">
                                    <label class="col-form-label" for="TipoSolicitudCam">Tipo de Recinto</label>
                                    <input formControlName="TipoSolicitudCam" name="TipoSolicitudCam" class="form-control" id="TipoSolicitudCam" type="text" value="">
                                </div>

                                <div class="form-group col-md-3 col-sm-6">
                                    <label class="col-form-label" for="Codigo">Código</label>
                                    <input formControlName="Codigo" name="Codigo" class="form-control" id="Codigo" type="text" value="">
                                </div>

                                <div class="form-group col-md-3 col-sm-6">
                                    <label class="col-form-label" for="FechaSolicitud">Fecha Solicitud</label>
                                    <p-calendar appendTo="body" formControlName="FechaSolicitud" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" [showTime]="true" hourFormat="24"></p-calendar>
                                </div>
                                
                                <div class="form-group col-md-3 col-sm-6">
                                    <label class="col-form-label" for="EstadoSolicitudCam">Estado</label>
                                    <input formControlName="EstadoSolicitudCam" name="EstadoSolicitudCam" class="form-control" inputStyleClass="form-control" [ngClass]="displayFieldCss('EstadoSolicitudCam')" type="text" value="">
                                </div>        
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="row">
            <div class="col-md-6" [ngClass]="{ 'col-md-6': almacenObligatorio, 'col-md-12': !almacenObligatorio }">
                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsedDatosOperador = !isCollapsedDatosOperador" [attr.aria-expanded]="!isCollapsedDatosOperador" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-file-text-o"></i> Datos Operador de Campaña
                            <i *ngIf="isCollapsedDatosOperador" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedDatosOperador" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body-detalle">
                        <div class="collapse group-filtros" id="collapseCabeceraOperador" [ngbCollapse]="isCollapsedDatosOperador">

                            <div class="row">

                                <div *ngIf="solicitudCam" class="form-group col-xl-6 col-lg-12 col-md-3 col-sm-6">
                                    <label class="col-form-label" for="OperadorRazonSocial">Razón Social</label>
                                    <!-- This field is disabled when building on the parent -->
                                    <input formControlName="OperadorRazonSocial" name="OperadorRazonSocial"
                                        class="form-control" id="OperadorRazonSocial" type="text" value="">
                                </div>
                                
                                <div *ngIf="solicitudCam" class="form-group col-xl-3 col-lg-6 col-md-3 col-sm-6">
                                    <label class="col-form-label" for="OperadorNif">NIF</label>
                                    <!-- This field is disabled when building on the parent -->
                                    <input formControlName="OperadorNif" name="OperadorNif"
                                        class="form-control" id="OperadorNif" type="text" value="">
                                </div>

                                <div *ngIf="solicitudCam" class="form-group col-xl-3 col-lg-6 col-md-3 col-sm-6">
                                    <label class="col-form-label" for="OperadorTelefono">Teléfono</label>
                                    <!-- This field is disabled when building on the parent -->
                                    <input formControlName="OperadorTelefono" name="OperadorTelefono"
                                        class="form-control" id="OperadorTelefono" type="text" value="">
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div *ngIf="almacenObligatorio" class="col-md-6">
                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsedDatosCicloCorto = !isCollapsedDatosCicloCorto" [attr.aria-expanded]="!isCollapsedDatosCicloCorto" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-file-text-o"></i> Datos Relativos al ciclo corto
                            <i *ngIf="isCollapsedDatosCicloCorto" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedDatosCicloCorto" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body-detalle">
                        <div class="collapse group-filtros" id="collapseDatosCicloCorto" [ngbCollapse]="isCollapsedDatosCicloCorto">
                            
                            <div *ngIf="!mostrarDesplegableAlmacenes" class="row">
                                <div class="form-group col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                    <label class="col-form-label" for="AlmacenExportacionCicloCorto">Almacén aceptado/autorizado para exportación</label>
                                    <!-- This field is disabled when building on the parent -->
                                    <input formControlName="AlmacenExportacionCicloCorto" name="AlmacenExportacionCicloCorto"
                                        class="form-control" id="AlmacenExportacionCicloCorto" type="text" value="">
                                </div>
                            </div>

                            <ng-container *ngIf="mostrarDesplegableAlmacenes">
                                <div class="row" *ngIf="almacenes?.length >= 0">
                                    <div class="form-group col-md-12">
                                        <label class="col-form-label" [ngClass]="{ 'required-field': isFieldRequired('IdAlmacenExportacionCicloCorto') }" for="IdAlmacenExportacionCicloCorto" title="Almacén">Almacén aceptado/autorizado para exportación</label>
                                        <ng-select appendTo="body"
                                            loadingText="Cargando..."
                                            [items]="almacenes"
                                            [readonly]="!almacenes || almacenes?.length === 0"
                                            bindLabel="RegistroSanitario"
                                            bindValue="Id"
                                            formControlName="IdAlmacenExportacionCicloCorto"
                                            [loading]="almacenes === null"
                                            placeholder="-- Seleccione un Almacén --"
                                            [ngClass]="displayFieldCssNgSelect('IdAlmacenExportacionCicloCorto')"
                                            notFoundText="Almacén no encontrado"
                                            aria-describedby="validationAlmacenFeedback"
                                            clearAllText="Eliminar selección">
                                            <ng-template ng-option-tmp let-item="item">
                                                <div container="body" ngbTooltip="{{ item.RegistroSanitario }}">
                                                    {{ item.RegistroSanitario + ' | ' + item.RazonSocial + ' | ' + item.IdMunicipioDescripcion + ' (' + item.IdProvinciaDescripcion + ')' }}</div>
                                            </ng-template>
                                        </ng-select>
    
                                        <div id="validationAlmacenFeedback" class="invalid-feedback d-block" *ngIf="almacenObligatorio && almacenes?.length > 0 && isFieldInvalid('IdAlmacenExportacionCicloCorto','required')">
                                            Almacén es obligatorio
                                        </div>
                                    </div>
                                    <div *ngIf="almacenes?.length === 0" class="nota-info error unset-height">
                                        <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> No hay almacenes autorizados para exportación en la campaña</label>
                                    </div>
    
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>

            </div>            
        </div>

    </form>

</div>
